module.exports = __webpack_public_path__ + "img/tdybs.036881dd.jpg";